import { ReactNode } from 'react'
import cn from 'classnames/bind'

import PlainHelperText from 'app/common/ui-next/plain-helper-text/plain-helper-text'
import styles from './content-group.module.scss'

const cx = cn.bind(styles)

type Props = {
  children: ReactNode
  className?: string
  header?: string | ReactNode
  headerContent?: ReactNode
  transparentBackground?: boolean
  babyHeader?: boolean
  normalHeader?: boolean
  error?: boolean
  helperText?: string
}

const ContentGroup = ({
  children,
  className,
  header,
  headerContent,
  transparentBackground,
  babyHeader,
  normalHeader,
  error,
  helperText,
}: Props) => {
  const rootClassName = cx(
    styles.root,
    {
      background: !transparentBackground,
      error,
      isHelperText: !!helperText,
    },
    className,
  )

  const headerClassName = cx(styles.header, {
    babyHeader,
    strangeHeader: !babyHeader && !normalHeader,
    normalHeader,
  })

  const headerMain = header && <h3 className={headerClassName}>{header}</h3>
  const headerLine = headerContent ? (
    <div className={styles.headerLine}>
      {headerMain}
      {headerContent}
    </div>
  ) : (
    headerMain
  )

  return (
    <div className={rootClassName}>
      {headerLine}
      {children}

      {helperText && (
        <PlainHelperText className={styles.helperText} error={error}>
          {helperText}
        </PlainHelperText>
      )}
    </div>
  )
}

export default ContentGroup
